// The six toy silhouettes (§0.5 names, GDD §5.2): each gun is a recipe over the part-kit. Colours are
// palette tokens outside the blaze hue band (25–70°, derived shade/light included); tests/art checks it.
import type { GunRecipe } from './types.ts';

export const GUN_RECIPES: readonly GunRecipe[] = [
  // T1 Cork Popper: a fat pop-gun tube with a cork on a string.
  {
    tier: 1,
    main: 'confetti.2',
    second: 'material.steel',
    accent: 'ui.cream2',
    gripTok: 'mach.front',
    receiver: { kind: 'round', x: -26, y: -13, w: 32, h: 26 },
    barrel: { kind: 'tube', x: 6, len: 26, th: 16 },
    muzzle: { len: 12, th: 18 },
    grip: { x: -20, w: 15, len: 20, deg: 14 },
    stock: { kind: 'stub', len: 10, h: 18 },
    mag: { kind: 'none' },
    top: { kind: 'cork' },
    decal: { kind: 'dots' },
  },
  // T2 Pea Pistol: a chubby pistol with a pea hopper on top.
  {
    tier: 2,
    main: 'tier.2',
    second: 'ui.buyDark',
    accent: 'glow.valid',
    gripTok: 'mach.front',
    receiver: { kind: 'round', x: -22, y: -14, w: 32, h: 26 },
    barrel: { kind: 'fat', x: 10, len: 16, th: 17 },
    muzzle: { len: 12, th: 19 },
    grip: { x: -16, w: 16, len: 22, deg: 10 },
    stock: { kind: 'none', len: 0, h: 0 },
    mag: { kind: 'hopper' },
    top: { kind: 'none' },
    decal: { kind: 'stripe' },
  },
  // T3 Six-Spinner: a six-colour toy revolver.
  {
    tier: 3,
    main: 'tier.3',
    second: 'material.steel',
    accent: 'ui.money',
    gripTok: 'tier.4',
    receiver: { kind: 'box', x: -24, y: -13, w: 30, h: 24 },
    barrel: { kind: 'rib', x: 6, len: 30, th: 14 },
    muzzle: { len: 12, th: 16 },
    grip: { x: -22, w: 15, len: 24, deg: 22 },
    stock: { kind: 'none', len: 0, h: 0 },
    mag: { kind: 'cylinder6' },
    top: { kind: 'sight' },
    decal: { kind: 'star' },
  },
  // T4 Fizz Blaster: a finned soda-can blaster.
  {
    tier: 4,
    main: 'tier.4',
    second: 'glow.select',
    accent: 'machine.caster',
    gripTok: 'mach.front',
    receiver: { kind: 'can', x: -22, y: -17, w: 32, h: 34 },
    barrel: { kind: 'fins', x: 10, len: 26, th: 15 },
    muzzle: { len: 12, th: 17 },
    grip: { x: -14, w: 15, len: 20, deg: 10 },
    stock: { kind: 'none', len: 0, h: 0 },
    mag: { kind: 'none' },
    top: { kind: 'none' },
    decal: { kind: 'bubbles' },
  },
  // T5 Pump Boomer: a long pump-action toy with a gold stock.
  {
    tier: 5,
    main: 'target.balloon',
    second: 'material.steel',
    accent: 'tier.7',
    gripTok: 'mach.front',
    receiver: { kind: 'long', x: -22, y: -12, w: 38, h: 22 },
    barrel: { kind: 'fat', x: 16, len: 32, th: 14 },
    muzzle: { len: 12, th: 16 },
    grip: { x: -16, w: 14, len: 20, deg: 16 },
    stock: { kind: 'full', len: 22, h: 20 },
    mag: { kind: 'pump' },
    top: { kind: 'none' },
    decal: { kind: 'chevron' },
  },
  // T6 Star Ranger: a long toy blaster with a star scope.
  {
    tier: 6,
    main: 'tier.8',
    second: 'tier.7',
    accent: 'tier.3',
    gripTok: 'mach.front',
    receiver: { kind: 'long', x: -24, y: -12, w: 40, h: 22 },
    barrel: { kind: 'rib', x: 16, len: 38, th: 13 },
    muzzle: { len: 12, th: 15 },
    grip: { x: -16, w: 14, len: 20, deg: 16 },
    stock: { kind: 'full', len: 24, h: 20 },
    mag: { kind: 'none' },
    top: { kind: 'starScope' },
    decal: { kind: 'star' },
  },
];

/** Decal colour per gun (a token that reads on the receiver). */
export const GUN_DECAL: readonly string[] = [
  'ui.cream2',
  'glow.valid',
  'ui.money',
  'ui.cream',
  'ui.cream',
  'ui.money',
];
